import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Card, CardHeader, CardText} from "material-ui/Card";
import {viewStyles} from "../shared/styles-view";

/**
 * A component for containing expandable Discount instructions content
 *
 */
class DiscountBXGYInstructions extends Component {
    render() {

        const {type} = this.props;

        return (
            <Card>
                <CardHeader
                    subtitle="How to Create a BXGY Discount"
                    actAsExpander={true}
                    showExpandableButton={true}
                />
                <CardText expandable={true}>
                    <p style={viewStyles.fieldParagraph}>
                        You can select a preset BOGO-style Discount or assemble a custom BXGY Discount.
                    </p>
                    <p style={viewStyles.fieldHeader}>
                        Preset BXGY Discount
                    </p>
                    <p style={viewStyles.fieldParagraph}>
                        To quickly add a generic BXGY Discount, select the desired Preset:
                    </p>
                    <ul style={viewStyles.fieldMediumColor}>
                        <li>
                            <strong>Buy Any X Products = Get Any Y Products of Equal or Lesser Value</strong>:<br/>
                            If the customer purchases X of any Product, the Discount offers any Y Product(s) of equal
                            or lesser value.
                            <br/>
                            <em>Example</em>: Buy 2 of any Product, get 1 of any Product
                            <br/><br/>
                        </li>
                        <li>
                            <strong>Buy Any X Products = Get Y Same Products</strong>:<br/>
                            If the customer purchases X of any Product, the Discount offers Y of
                            the <em>same</em> Product(s).
                            <br/>
                            <em>Example</em>: Buy 1 of any Product, get 1 of the same Product
                            <br/><br/>
                        </li>
                        <li>
                            <strong>Buy X Products From Any Category = Get Y Products From Same Category</strong>:
                            If the customer purchases X Product(s) of any Category, the Discount offers Y Product(s)
                            of that same Category.
                            <br/>
                            <em>Example</em>: Buy 2 Products of any Category, get 1 Product from that same Category
                            <br/><br/>
                        </li>
                    </ul>

                    <p style={viewStyles.fieldHeader}>
                        Custom BXGY Discount
                    </p>
                    <p style={viewStyles.fieldParagraph}>
                        To assemble a custom Discount, click
                        the <strong>Add Buy Item</strong> and <strong>Add Get Item</strong> buttons to assemble
                        items to add to the BXGY Discount.
                        <br/>
                        Each item added reflects what eligible Products or Categories may be applied:
                    </p>
                    <ul style={viewStyles.fieldMediumColor}>
                        <li>Select <strong>All Products</strong> to allow any Product of the <em>{type}</em> Product
                            Type to qualify for this Discount.
                        </li>
                        <li>Select <strong>All Categories</strong> to allow any Category of the <em>{type}</em> Product
                            Type to qualify for this Discount.
                        </li>
                        <li>Select <strong>Add a Category</strong> to choose a specific Category.</li>
                        <li>Select <strong>Add a Product</strong> to choose a specific Product.</li>
                    </ul>
                    <p style={viewStyles.fieldParagraph}>
                        You can add an "All" selection or make a specific selection. Note:
                        <br/>
                        If you select "All Products" or "All Categories", you will not be able to add more selections.
                        <br/>
                        If you select a specific Category, you can only add more Categories.
                        <br/>
                        If you select a specific Product, you can only add more Products.
                        <br/><br/>
                        "Qty" applies to each item individually. Therefore, a <em>Buy Qty</em> of 2 means the
                        Customer must purchase 2 of each added item.
                        <br/><br/>
                        If multiple items are added, choose whether the items MUST be included (AND) or MAY be
                        included (OR). The chosen Qty dictates how many <em>AND</em> items are allowed. For
                        example, a <em>Buy Qty</em> of 2 allows for two items.
                        <br/>
                        If <em>OR</em> is chosen, multiple items may be added.
                        <br/>
                        If only item item is added, the AND/OR selection does not matter.
                        <br/><br/>
                        The Discount will process items in the order they are added. To change the order, remove
                        items and re-add as needed. Click an item's <strong>X</strong> icon to remove it.
                        <br/><br/>
                        You must add at least 1 Buy selection and 1 Get selection.
                    </p>
                </CardText>
            </Card>
        )
    }
}

DiscountBXGYInstructions.propTypes = {
    type: PropTypes.string
};

export default DiscountBXGYInstructions;



// WEBPACK FOOTER //
// ./src/Fuse/components/DiscountBXGYInstructions.js